import classNames from 'classnames';
import { ElementType, FC, useMemo } from 'react';

import { CallBlurType } from '@gem/call/constants';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import styles from './BackgroundItem.styles.m.css';

interface IBackgroundItemProps {
  background?: string;
  icon: ElementType;
  isActive?: boolean;
  blurType: CallBlurType;
  onClick(type: CallBlurType): void;
}

export const BackgroundItem: FC<IBackgroundItemProps> = (props) => {
  const { background, icon, onClick, isActive, blurType } = props;

  const backgroundStyle = useMemo(
    () =>
      background
        ? {
            background: `url(${background})`,
          }
        : {},
    [background]
  );

  const onItemClick = (): void => {
    if (isActive) {
      return;
    }
    onClick(blurType);
  };

  return (
    <button
      className={classNames(styles.blurItem, {
        [styles.blurItemActive]: isActive,
      })}
      style={backgroundStyle}
      onClick={onItemClick}
    >
      <IconView
        Icon={icon}
        size={IconViewSizes.Medium}
      />
    </button>
  );
};
